import { RandomUtils } from '@colonist/utils';
import { LobbyImage } from '@colonist/types';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { StorageWrapper } from '../StorageWrapper.ts';
import { clientI18n } from '../ClientI18n.ts';
import { ClientUserState } from '../ClientUserState.ts';
export class LogRocketController {
    async init() {
        if (!this.active) return;
        if (this.logRocket != undefined) return;
        const { default: logRocket } = await import('logrocket');
        this.logRocket = logRocket;
        await this.logRocket.init(UIUtilsEjsVariables.logRocketId);
    }
    set(session) {
        var _ClientUserState_userState;
        if (this.logRocket == undefined) return;
        if (ClientUserState.userState == undefined) return;
        const karmaText = ClientUserState.userState.getPlayerKarmaStatusText();
        karmaText.options = {
            ...karmaText.options,
            lng: 'en'
        };
        const languageAgnosticKarmaTextStatus = clientI18n.t(karmaText.key, karmaText.options);
        this.logRocket.identify(session.id, {
            name: ClientUserState.userState.username,
            // Add your own custom user variables here, ie:
            loggedIn: String((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn),
            karmaTextStatus: languageAgnosticKarmaTextStatus,
            icon: String(LobbyImage[ClientUserState.userState.icon])
        });
    }
    constructor(){
        this.active = false;
        this.USER_SELECTION_DENOMINATOR = 10000;
        if (UIUtilsEjsVariables.logRocketId == '') return;
        const logRocketStorageActive = StorageWrapper.getLogRocket();
        if (logRocketStorageActive == false) return;
        const random = RandomUtils.randomIntBetween(0, this.USER_SELECTION_DENOMINATOR);
        this.active = logRocketStorageActive || random == 1;
        if (!logRocketStorageActive) StorageWrapper.setLogRocket(this.active);
    }
}
